<mat-menu #menu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item [matMenuTriggerFor]="templatesMenu" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.templates' | transloco }}</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="reportsMenu" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.reports' | transloco }}</span>
  </button>
</mat-menu>

<mat-menu #templatesMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item [matMenuTriggerFor]="packagingPartTemplateMenuCreate" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.buttons.createTemplate' | transloco}}</span>
  </button>
  <button mat-menu-item (click)="viewReportTemplates()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.buttons.viewTemplates' | transloco }}</span>
  </button>
</mat-menu>

<mat-menu #reportsMenu="matMenu" [overlapTrigger]="false">
  <!-- <button mat-menu-item disabled type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.buttons.createReport' | transloco}}</span>
  </button> -->
  <button mat-menu-item (click)="viewReports()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.buttons.viewReports' | transloco }}</span>
  </button>
</mat-menu>

<mat-menu #packagingPartTemplateMenuCreate="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="createPackagingSystemReportTemplate()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.packagingSystemTemplate' | transloco }}</span>
  </button>
  <button mat-menu-item (click)="createPackagingReportTemplate()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.packagingUnitTemplate' | transloco }}</span>
  </button>
  <button mat-menu-item (click)="createComponentReportTemplate()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.componentTemplate' | transloco }}</span>
  </button>
  <!-- <button mat-menu-item (click)="createMaterialReportTemplate()" type="button">
    <mat-icon>folder</mat-icon>
    <span>{{ 'report.materialTemplate' | transloco }}</span>
  </button> -->
</mat-menu>
